/**
 * CrashReporter — capture les erreurs de rendu React non gérées (qui provoquaient un
 * écran noir/page blanche silencieuse en production) : affiche un message clair à
 * l'utilisateur + envoie un rapport au backend pour alerter l'admin par email.
 */
import React from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export class CrashReporter extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    try {
      fetch(`${BACKEND_URL}/api/client-error-report`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message: error?.message || String(error),
          stack: info?.componentStack || '',
          page_url: window.location.href,
        }),
      }).catch(() => {});
    } catch { /* ne jamais faire planter le fallback lui-même */ }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-black flex items-center justify-center p-6" data-testid="crash-fallback-screen">
          <div className="max-w-md text-center space-y-4">
            <p className="text-2xl font-black text-white">Oups, une erreur est survenue</p>
            <p className="text-sm text-zinc-400">
              L'équipe a été notifiée automatiquement. Rechargez la page pour continuer.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="px-5 py-2.5 rounded-xl font-bold text-white bg-gradient-to-r from-fuchsia-600 to-pink-500"
              data-testid="crash-reload-btn"
            >
              Recharger la page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default CrashReporter;
